import React, { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const JobPage: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    wechat: '',
    school: '',
    difficulties: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.name || !formData.phone || !formData.school) {
      alert('请填写必填项');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const response = await fetch('https://readdy.ai/api/form/d4860g7jsic9gsa4uq7g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          name: formData.name,
          phone: formData.phone,
          wechat: formData.wechat,
          school: formData.school,
          difficulties: formData.difficulties
        })
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          phone: '',
          wechat: '',
          school: '',
          difficulties: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 to-indigo-100 py-20">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between">
            <div className="w-full lg:w-1/2">
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                海内外求职
                <span className="block text-blue-600">专业指导服务</span>
              </h1>
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                从职业规划到求职成功，我们提供全方位的专业指导服务，
                帮助您在竞争激烈的就业市场中脱颖而出，实现职业梦想。
              </p>
              <div className="flex space-x-4">
                <button className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap">
                  立即咨询
                </button>
                <button className="border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap">
                  了解更多
                </button>
              </div>
            </div>
            <div className="hidden lg:block w-1/2">
              <img 
                src="https://public.readdy.ai/ai/img_res/e51396e8e4fc4e988291006068ce24e4.jpg"
                alt="海内外求职指导服务"
                className="w-full h-auto max-w-full object-contain rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Core Service Advantages */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">核心服务优势</h2>
            <p className="text-xl text-gray-600">三大核心优势，助您职场成功</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-xl text-center">
              <h3 className="text-4xl font-bold text-blue-600 mb-4">更高</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                <strong>搭乘产业革命浪潮的职业规划</strong><br/>
                顶尖战略咨询+猎头公司+10亿大数据
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-xl text-center">
              <h3 className="text-4xl font-bold text-green-600 mb-4">更快</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                <strong>独家抢跑式岗位内推</strong><br/>
                抢跑式内推+直录实习+真题提前做
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-xl text-center">
              <h3 className="text-4xl font-bold text-purple-600 mb-4">更强</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                <strong>打造差异化竞争力</strong><br/>
                专家教学+项目实训+AI赋能
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 前途迷茫怎么办 */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">前途迷茫怎么办？</h2>
            <p className="text-xl text-gray-600">战略咨询+猎头公司+大数据，顶级职业规划帮你搭乘产业革命浪潮</p>
          </div>

          {/* 合作公司 */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-center text-gray-900 mb-12">顶级合作伙伴</h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-xl shadow-lg text-center">
                <img 
                  src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/5b843cb0f20fd51f7bf692abae7c1bb3.jpeg"
                  alt="麦肯锡"
                  className="w-full max-w-96 h-48 mx-auto mb-6 object-contain"
                />
                <h4 className="text-xl font-bold text-gray-900 mb-3">麦肯锡</h4>
                <p className="text-gray-600">全球第一战略咨询公司，为各国政府及500强企业提供战略，针对庞杂的发展问题给予解决方案</p>
              </div>
              
              <div className="bg-white p-8 rounded-xl shadow-lg text-center">
                <img 
                  src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/345bc33662cbf69e1a3a653d79695249.webp"
                  alt="领英"
                  className="w-full max-w-96 h-48 mx-auto mb-6 object-contain"
                />
                <h4 className="text-xl font-bold text-gray-900 mb-3">领英</h4>
                <p className="text-gray-600">全球最大的职场社交平台，用户数超过10亿，拥有遍布全球的200多个国家和地区的影响力以及强大的行业洞察力</p>
              </div>
              
              <div className="bg-white p-8 rounded-xl shadow-lg text-center">
                <img 
                  src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/9c338f734242fb1c56e10bec8fcf5bd3.jpeg"
                  alt="光辉国际"
                  className="w-full max-w-96 h-48 mx-auto mb-6 object-contain"
                />
                <h4 className="text-xl font-bold text-gray-900 mb-3">光辉国际</h4>
                <p className="text-gray-600">全球最大猎头公司，纽交所上市，为苹果、英伟达、亚马逊、特斯拉、三星等企业输送超40%的CXO级高管</p>
              </div>
            </div>
          </div>

          {/* 职业规划分析 */}
          <div className="space-y-12">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex flex-col lg:flex-row items-center gap-8">
                <div className="lg:w-1/2 w-full">
                  <img 
                    src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/75ca1f58430944fb5b99a9bd6dd68c01.png"
                    alt="增长产业分析"
                    className="w-full h-auto max-w-full object-contain rounded-lg"
                  />
                </div>
                <div className="lg:w-1/2">
                  <h4 className="text-2xl font-bold text-gray-900 mb-4">增长产业分析</h4>
                  <p className="text-lg text-blue-600 font-semibold mb-4">200余个国家和地区的政策分析及全球140万亿美金资本流向</p>
                  <div className="space-y-3">
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700">各国支柱产业的革新方向</p>
                    </div>
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700">全球新兴行业未来风口</p>
                    </div>
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700">传统行业的转机</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex flex-col lg:flex-row-reverse items-center gap-8">
                <div className="lg:w-1/2 w-full">
                  <img 
                    src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/73566b8e1382d2b12703aed97a93eddd.webp"
                    alt="求职最快路径分析"
                    className="w-full h-auto max-w-full object-contain rounded-lg"
                  />
                </div>
                <div className="lg:w-1/2">
                  <h4 className="text-2xl font-bold text-gray-900 mb-4">求职最快路径分析</h4>
                  <p className="text-lg text-green-600 font-semibold mb-4">全球10亿人才的职业生涯路径及教育背景</p>
                  <div className="space-y-3">
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-green-600 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700">各大名企招聘目标校及半目标校</p>
                    </div>
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-green-600 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700">各岗位录取及被拒人才简历库</p>
                    </div>
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-green-600 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700">典型人才求职、跳槽及升职路径</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex flex-col lg:flex-row items-center gap-8">
                <div className="lg:w-1/2 w-full">
                  <img 
                    src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/d46a94d0be8a78b9f4e17c6d225532eb.png"
                    alt="职业生涯高度分析"
                    className="w-full h-auto max-w-full object-contain rounded-lg"
                  />
                </div>
                <div className="lg:w-1/2">
                  <h4 className="text-2xl font-bold text-gray-900 mb-4">职业生涯高度分析</h4>
                  <p className="text-lg text-orange-600 font-semibold mb-4">匹配您的职业生涯目标：海内外上市公司高管、创业领军人、高校科研人员、各领域技术专家、社会活动家以及艺术家等</p>
                  <div className="space-y-3">
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-orange-600 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700">学术背景分析</p>
                    </div>
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-orange-600 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700">职业路径分析</p>
                    </div>
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-orange-600 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700">重大成果分析</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 资历不够门槛怎么办 */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">简历不够门槛怎么办？</h2>
            <p className="text-xl text-gray-600">抢跑式岗位内推帮你提前把握高含金量机遇</p>
          </div>

          <div className="space-y-8">
            <div className="bg-gradient-to-br from-red-50 to-red-100 p-8 rounded-xl">
              <div className="flex flex-col lg:flex-row items-center gap-8">
                <div className="lg:w-1/2 w-full">
                  <img 
                    src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/79a4c1f8b7c09c1be87c95d35c929183.png"
                    alt="抢跑式内推"
                    className="w-full h-auto max-w-full object-contain rounded-lg"
                  />
                </div>
                <div className="lg:w-1/2">
                  <h4 className="text-2xl font-bold text-gray-900 mb-3">岗位万人投 抢不过？</h4>
                  <p className="text-lg text-red-600 font-semibold mb-4">抢跑式内推</p>
                  <p className="text-gray-700 leading-relaxed">提前获得内部岗位信息，通过内推渠道避开激烈竞争，在岗位公开前就已直面招聘官，大幅提升录取概率。我们与2000+全球名企建立深度合作关系，为您提供独家内推机会。</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-xl">
              <div className="flex flex-col lg:flex-row-reverse items-center gap-8">
                <div className="lg:w-1/2 w-full">
                  <img 
                    src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/0794f6dc906e45c82d08462aae79609d.png"
                    alt="高含金量实习"
                    className="w-full h-auto max-w-full object-contain rounded-lg"
                  />
                </div>
                <div className="lg:w-1/2">
                  <h4 className="text-2xl font-bold text-gray-900 mb-3">第一份实习最难找？</h4>
                  <p className="text-lg text-blue-600 font-semibold mb-4">直录高含金量实习岗位</p>
                  <p className="text-gray-700 leading-relaxed">跳过层层筛选，直接获得知名企业实习机会。我们与顶级企业建立直通渠道，为您匹配最适合的实习岗位，为简历增添亮点，为未来求职奠定坚实基础。</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-xl">
              <div className="flex flex-col lg:flex-row items-center gap-8">
                <div className="lg:w-1/2 w-full">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Interview%20and%20exam%20preparation%20with%20real%20test%20questions%2C%20professional%20coaching%20session%2C%20candidates%20practicing%20with%20actual%20materials%2C%20comprehensive%20test%20preparation&width=500&height=300&seq=exam-prep-detailed&orientation=landscape"
                    alt="真题练习"
                    className="w-full h-auto max-w-full object-contain rounded-lg"
                  />
                </div>
                <div className="lg:w-1/2">
                  <h4 className="text-2xl font-bold text-gray-900 mb-3">笔试面试做不对？</h4>
                  <p className="text-lg text-green-600 font-semibold mb-4">在考真题提前练</p>
                  <p className="text-gray-700 leading-relaxed">获得最新真题资源，提前熟悉考试形式和内容。我们收集各大企业最新笔试面试真题，提供专业解析和模拟练习，大幅提升通过率，让您在考试中游刃有余。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 能力不够怎么办 */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">能力不够怎么办？</h2>
            <p className="text-xl text-gray-600">专家教学+AI赋能，帮你打造差异化竞争力</p>
          </div>

          <div className="space-y-8">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex flex-col lg:flex-row items-center gap-8">
                <div className="lg:w-1/2 w-full">
                  <img 
                    src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/03d757083e30709c03594c71e833436d.png"
                    alt="资深专家教学"
                    className="w-full h-auto max-w-full object-contain rounded-lg"
                  />
                </div>
                <div className="lg:w-1/2">
                  <h4 className="text-2xl font-bold text-gray-900 mb-3">达不到招聘要求怎么办？</h4>
                  <p className="text-lg text-blue-600 font-semibold mb-4">资深专家手把手教学</p>
                  <p className="text-gray-700 leading-relaxed">行业顶尖专家一对一指导，传授实战经验和核心技能。我们的导师团队来自各行业领军企业，拥有丰富的实战经验，为您提供个性化的专业指导，快速提升专业能力和职场竞争力。</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex flex-col lg:flex-row-reverse items-center gap-8">
                <div className="lg:w-1/2 w-full">
                  <img 
                    src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/766879f15c27aba53f9caece77d379f6.png"
                    alt="内部项目实训"
                    className="w-full h-auto max-w-full object-contain rounded-lg"
                  />
                </div>
                <div className="lg:w-1/2">
                  <h4 className="text-2xl font-bold text-gray-900 mb-3">学校专业落后于行业前沿5-10年怎么办？</h4>
                  <p className="text-lg text-green-600 font-semibold mb-4">顶尖公司内部项目实训</p>
                  <p className="text-gray-700 leading-relaxed">参与真实项目实战，积累宝贵工作经验。我们提供来自合作企业的真实项目，让您在实践中学习，在项目中成长，建立专业作品集，为求职增加实战经验和成功案例。</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex flex-col lg:flex-row items-center gap-8">
                <div className="lg:w-1/2 w-full">
                  <img 
                    src="https://readdy.ai/api/search-image?query=AI-powered%20skill%20enhancement%20and%20productivity%20tools%2C%20modern%20technology%20assisting%20professional%20development%2C%20artificial%20intelligence%20in%20workplace%2C%20future%20skills%20training&width=500&height=300&seq=ai-enhancement-detailed&orientation=landscape"
                    alt="AI提升工作能力"
                    className="w-full h-auto max-w-full object-contain rounded-lg"
                  />
                </div>
                <div className="lg:w-1/2">
                  <h4 className="text-2xl font-bold text-gray-900 mb-3">担心未来被AI淘汰怎么办？</h4>
                  <p className="text-lg text-purple-600 font-semibold mb-4">掌握前沿科技，AI全面赋能</p>
                  <p className="text-gray-700 leading-relaxed">运用最新AI工具提升工作效率，掌握未来职场必备技能。我们教授最前沿的AI应用技术，帮您掌握人工智能时代的核心竞争力，让您在职场中脱颖而出，成为不可替代的人才。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 全流程服务陪伴 */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">全流程服务陪伴</h2>
            <p className="text-xl text-gray-600">我们也都曾经历过迷茫，全流程陪伴让你的职场之路更省心</p>
          </div>
          
          <div className="flex justify-center">
            <img 
              src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/1353f3284aba4b4dd3dea0d9712e2b21.jpeg"
              alt="全流程服务陪伴流程图"
              className="w-full max-w-6xl h-auto object-contain"
            />
          </div>
        </div>
      </section>

      {/* Free Career Consultation Form */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-purple-700">
        <div className="container mx-auto px-6">
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-white mb-4">免费职业规划咨询</h2>
              <p className="text-xl text-blue-100">专业导师一对一指导，助您规划职业发展道路</p>
            </div>
            
            <div className="bg-white rounded-2xl p-8 shadow-2xl">
              <form onSubmit={handleSubmit} data-readdy-form>
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                      姓名 <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                      联系电话 <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="请输入您的手机号"
                    />
                  </div>
                </div>
                
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="wechat" className="block text-sm font-medium text-gray-700 mb-2">
                      微信号
                    </label>
                    <input
                      type="text"
                      id="wechat"
                      name="wechat"
                      value={formData.wechat}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="请输入您的微信号"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="school" className="block text-sm font-medium text-gray-700 mb-2">
                      在读（毕业）院校 <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="school"
                      name="school"
                      value={formData.school}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="请输入您的院校名称"
                    />
                  </div>
                </div>
                
                <div className="mb-6">
                  <label htmlFor="difficulties" className="block text-sm font-medium text-gray-700 mb-2">
                    目前面临的困难和困惑
                  </label>
                  <textarea
                    id="difficulties"
                    name="difficulties"
                    value={formData.difficulties}
                    onChange={handleInputChange}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                    placeholder="请详细描述您在职业发展中遇到的困难和困惑..."
                  />
                  <div className="text-right text-sm text-gray-500 mt-1">
                    {formData.difficulties.length}/500
                  </div>
                </div>
                
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 px-6 rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? '提交中...' : '立即获取免费咨询'}
                </button>
                
                {submitStatus === 'success' && (
                  <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                    <p className="text-green-800 text-center">提交成功！我们的专业顾问将在24小时内与您联系。</p>
                  </div>
                )}
                
                {submitStatus === 'error' && (
                  <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-red-800 text-center">提交失败，请稍后重试或直接联系我们。</p>
                  </div>
                )}
                
                <p className="text-xs text-gray-500 text-center mt-4">
                  我们承诺保护您的隐私信息，仅用于提供咨询服务
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default JobPage;
